import React from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import useStyles from './styles';

interface CardDurationInfoProps {
  className?: string;
  durationName?: string | null;
  duration?: string | null;
  link?: string;
  reverse?: boolean;
}

const CardDurationInfo: React.FC<CardDurationInfoProps> = ({
  className,
  durationName,
  duration,
  link,
  reverse = false,
}) => {
  const classes = useStyles();
  const name = link ? <Link to={link}>{durationName}</Link> : durationName;

  return (
    <Typography data-testid="cardInfo" className={cx(classes.helperText, className)}>
      {reverse ? duration : name}
      {durationName && duration && ' • '}
      {reverse ? name : duration}
    </Typography>
  );
};

export default CardDurationInfo;
